import { createStateReducer } from 'hooks/useSateReduxed';
import { reducers } from 'features/pay/constants';
const paymentActivity = createStateReducer(reducers.THANKED_PAYMENT);
export default paymentActivity;
